import { SidekickSupportedTms } from '@shared/generated/graphql';
import { EntityInfo, SupportedEntityType, TMSPageInfo } from './types';

export function getUberGtgPageInfo(url: string): TMSPageInfo {
  return {
    pageType: 'tms',
    tms: SidekickSupportedTms.UBER_GTG,
    entityInfo: getEntityInfo(url),
  };
}

function getEntityInfo(url: string): EntityInfo[] {
  const params = new URL(url).searchParams;
  // NOTE(jonathan): I've observed vinvno URL references with both lowercase and uppercase first letters.
  // I've tested that these both refer to the same entity.
  const maybeWrongCaseReference = params.get('vinvno');
  const entityReference = maybeWrongCaseReference?.toUpperCase();
  if (entityReference) {
    return [
      {
        entityType: SupportedEntityType.SHIPMENT,
        entityReference,
      },
    ];
  }
  return [];
}

export const _testOnly = {
  getEntityInfo,
};
